<template>
<div class="chapter">
<div class="inner_page">
<section>
<h1 class="navTitle">The Palphramonds</h1>
<h2 class="navTocTitle">Table of Contents</h2>
<nav epub:type="toc" id="toc">
<ol id="tocList">
<li class="navTocItem"><span href="#/cover" title="Link target outside of Sample"><span class="a-inner">Cover</span></span></li>
<li class="navTocItem"><a href="#/chapter0" title="Title Page"><span class="a-inner">Title Page</span></a></li>
<li class="navTocItem"><a href="#/chapter1" title="Note on Coinage"><span class="a-inner">Note on Coinage</span></a></li>
<li class="navTocItem"><a href="#/chapter2" title="Family Tree"><span class="a-inner">Family Tree</span></a></li>
<li class="navTocItem"><a href="#/chapter3" title="Book I"><span class="a-inner">Book I</span></a></li>
<li class="navTocItem"><a href="#/chapter4" title="Chapter 1"><span class="a-inner">Chapter 1</span></a></li>
<li class="navTocItem"><a href="#/chapter5" title="Chapter 2"><span class="a-inner">Chapter 2</span></a></li>
<li class="navTocItem"><a href="#/chapter6" title="Chapter 3"><span class="a-inner">Chapter 3</span></a></li>
<li class="navTocItem"><a href="#/chapter7" title="Chapter 4"><span class="a-inner">Chapter 4</span></a></li>
<li class="navTocItem"><span href="#/chapter8" title="Link target outside of Sample"><span class="a-inner">Chapter 5</span></span></li>
<li class="navTocItem"><span href="#/chapter9" title="Link target outside of Sample"><span class="a-inner">Book II</span></span></li>
<li class="navTocItem"><span href="#/chapter10" title="Link target outside of Sample"><span class="a-inner">Chapter 6</span></span></li>
<li class="navTocItem"><span href="#/chapter11" title="Link target outside of Sample"><span class="a-inner">Chapter 7</span></span></li>
<li class="navTocItem"><span href="#/chapter12" title="Link target outside of Sample"><span class="a-inner">Chapter 8</span></span></li>
<li class="navTocItem"><span href="#/chapter13" title="Link target outside of Sample"><span class="a-inner">Chapter 9</span></span></li>
<li class="navTocItem"><span href="#/chapter14" title="Link target outside of Sample"><span class="a-inner">Chapter 10</span></span></li>
<li class="navTocItem"><span href="#/chapter15" title="Link target outside of Sample"><span class="a-inner">Book III</span></span></li>
<li class="navTocItem"><span href="#/chapter16" title="Link target outside of Sample"><span class="a-inner">Chapter 11</span></span></li>
<li class="navTocItem"><span href="#/chapter17" title="Link target outside of Sample"><span class="a-inner">Chapter 12</span></span></li>
<li class="navTocItem"><span href="#/chapter18" title="Link target outside of Sample"><span class="a-inner">Chapter 13</span></span></li>
<li class="navTocItem"><span href="#/chapter19" title="Link target outside of Sample"><span class="a-inner">Chapter 14</span></span></li>
<li class="navTocItem"><span href="#/chapter20" title="Link target outside of Sample"><span class="a-inner">Chapter 15</span></span></li>
<li class="navTocItem"><span href="#/chapter21" title="Link target outside of Sample"><span class="a-inner">Book IV</span></span></li>
<li class="navTocItem"><span href="#/chapter22" title="Link target outside of Sample"><span class="a-inner">Chapter 16</span></span></li>
<li class="navTocItem"><span href="#/chapter23" title="Link target outside of Sample"><span class="a-inner">Chapter 17</span></span></li>
<li class="navTocItem"><span href="#/chapter24" title="Link target outside of Sample"><span class="a-inner">Chapter 18</span></span></li>
<li class="navTocItem"><span href="#/chapter25" title="Link target outside of Sample"><span class="a-inner">Chapter 19</span></span></li>
<li class="navTocItem"><span href="#/chapter26" title="Link target outside of Sample"><span class="a-inner">Chapter 20</span></span></li>
<li class="navTocItem"><span href="#/chapter27" title="Link target outside of Sample"><span class="a-inner">Book V</span></span></li>
<li class="navTocItem"><span href="#/chapter28" title="Link target outside of Sample"><span class="a-inner">Chapter 21</span></span></li>
<li class="navTocItem"><span href="#/chapter29" title="Link target outside of Sample"><span class="a-inner">Chapter 22</span></span></li>
<li class="navTocItem"><span href="#/chapter30" title="Link target outside of Sample"><span class="a-inner">Chapter 23</span></span></li>
<li class="navTocItem"><span href="#/chapter31" title="Link target outside of Sample"><span class="a-inner">Chapter 24</span></span></li>
<li class="navTocItem"><span href="#/chapter32" title="Link target outside of Sample"><span class="a-inner">Chapter 25</span></span></li>
<li class="navTocItem"><span href="#/chapter33" title="Link target outside of Sample"><span class="a-inner">Alphabetical List of Names</span></span></li>
<li class="navTocItem"><span href="#/chapter34" title="Link target outside of Sample"><span class="a-inner">The Quincunx</span></span></li>
<li class="navTocItem"><span href="#/chapter35" title="Link target outside of Sample"><span class="a-inner">Copyright</span></span></li>
</ol>
</nav>
<nav epub:type="landmarks" hidden="hidden" id="landmarks">
<h2>Guide</h2>
<ol id="landmarksList">
<li><span epub:type="cover" href="#/cover" title="Link target outside of Sample">Cover</span></li>
<li><a epub:type="bodymatter" href="#/chapter0">Start Reading</a></li>
<li><a epub:type="bodymatter" href="#/chapter3">Book I</a></li>
</ol>
</nav>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?59ea2701